import clsx from 'clsx';
import styles from 'components/UI/V3/Drawer/Body/DrawerBody.module.scss';
import React from 'react';

interface DrawerBodyProps {
    className?: string;
    children?: React.ReactNode;
}

export const DrawerBody: React.FC<DrawerBodyProps> = ({ children, className }) => {
    return <div className={clsx(styles.root, className)}>{children}</div>;
};
